// This solution "hijacks" input element containers and uses AJAX to submit the data instead of doing
// a full postback.  In the Sitecore development environment, this was causing a viewstate validation
// error that could not be reproduced outside of Sitecore.  So the following workaround was implemented:
//
// 1) Set ASP.NET control ClientIDMode="static"
// 2) This script updates the "name" attribute of each input element to match its "id" attribute (add data-sync-name="false" to bypass this behavior)
// 3) The form handler checks for postback using Request.RequestType == "POST" and reads values as Request.Form[theControl.ClientID]

(function ($) {

	if (!$.fn.validate) {
		console.warn('jQuery Validation plugin not available.');
		return;
	}
	prepAjaxForm();
	bindEvents();
	initRequiredCheckboxes();

	var submitDelaySelector = "[data-delay-submit]",
		formSubmissionTimer = null,
		submitDelay;

	function bindEvents() {
		$('body')
			.on('show.bs.modal', '.ajax-form', function (e) {
				if (submitDelay) {
					initSubmissionDelay();
				}
				autoPopulate(e.target);
				captureInitialValues(e.target);
				initFormRadios(e.target);
				initValidation(e.target);
				resetForm(e.target);
				if (!$(this).data("modal-opened")) {
					$(this).data("modal-opened", "true");
					trackInitialTags($(this), "init");
				}
			})
			.on('shown.bs.modal', '.ajax-form', function (e) {
				setFocusToFirstField(e.target);
			})
			.on('hidden.bs.modal', '.ajax-form', function () {
				if ($("body").find(submitDelaySelector).length) {
					toggleFormSubmission(false);
				}
			})
			.on('click', '.ajax-form .form-submit', trackAnalytics)
			.on('change', '.ajax-form .checkboxes[data-required] input[type=checkbox]', function () {
				validRequiredCheckboxes($(this).closest(".checkboxes"));
			});

		// Track last field copmpleted by the user for the "comp_n" Analytics tag
		window.lastActiveField = "";
		$('.ajax-form').find("input, select, textarea").on("change", function (e) {
			var formName = $(this).data("ajax-form-name"),
                labelName = formName ? formName : $(this).siblings('label:not(.error)').text();
			labelName += $(this).is(":radio") ? "-" + $(this).val() : "";
			window.lastActiveField = ($(this).val() != "") ? labelName : "";
			trackAnalytics(e);
		});

		$(document).ready(function () {
			if ($("body").find(submitDelaySelector).length) {
				submitDelay = Object.freeze({
					get: $("body").find(submitDelaySelector).data("delay-submit")
				});
			}
		});
	}

	function prepAjaxForm() {
		setManualTag = function (elems, mode) {
			var data,
				$form,
				$elems = $('.ajax-form').find(elems.join(","));
			$elems.each(function () {
				data = {};
				$form = $(this).closest('.ajax-form');
				data = $(this).data("analytics");
				if (data) {
					data.manual = mode;
					$(this).attr("data-analytics", JSON.stringify(data));
				} else {
					if ($(this).is(".btn-close")) {
						data = $.extend({}, $form.find('.form-cancel').data("analytics"), { "csg": "Exit", "manual": mode });
						$(this).attr("data-analytics", JSON.stringify(data));
					}
				}
			});
		};
		var clusters = [
                {
                	elems: [
                        '.btn-close[data-bs-dismiss=modal]',
                        '.form-cancel',
                        '.form-submit',
						'input[type=radio]'
                	],
                	mode: false
                }
		];
		$.each(clusters, function (i, v) {
			setManualTag(v.elems, v.mode);
		});
		$('.ajax-form').each(function(i, v) {
			$(v).attr('data-bs-backdrop', 'static');
			$('<div class="modal-sending-backdrop" />').insertBefore($(v).find('.modal-footer'));
		});
	}

	// jQuery Validation plugin only works at the <form> level.  Since the XOM template has a single top-level form element,
	// use of this this plugin may affect validation of other fields outside the scope of this ajax-form element.
	function initValidation(target) {
		var form = $(target).closest('form');
		form.off('validate');
		form.data('validator', null);
		form
            .validate({
            	ignore: '' // jQuery Validation ignores hidden fields by default, and our custom radios hide the <input> element
            })
            .resetForm();
		$('.ajax-form').find('input, select, textarea').removeClass('error');
	}

	function autoPopulate(target) {
		var $target = $(target);
		var values = $target.data('formValues');
		if (!values) return;
		for (var k in values) {
			if (!values.hasOwnProperty(k)) continue;
			var field = $target.find('[data-ajax-form-name="' + k + '"]');
			var type = field.attr('type');
			if (type === 'checkbox' || type === 'radio') {
				field.filter('[value="' + values[k] + '"]').attr('checked', true);
			} else {
				field.val(values[k]);
			}
		}
	}

	function captureInitialValues(target) {
		getFields(target).each(function () {
			var $this = $(this);
			if ($this.data('initialValue') !== undefined) return;
			$this.data('initialValue', $this.is('[type="radio"],[type="checkbox"]') ? $this.is(':checked') : $this.val());
		});
	}

	function restoreInitialValues(target) {
		getFields(target).each(function () {
			var $this = $(this);
			var initialValue = $this.data('initialValue');
			if (initialValue === null) return;
			if ($this.is('[type="radio"],[type="checkbox"]')) {
				$this.attr('checked', initialValue);
				$this.removeClass("invalid");
			} else {
				$this.val(initialValue);
			}
		});
	}

	function resetForm(target) {
		var $target = $(target);
		$target.find('.form-submit,.form-cancel').removeClass('hidden');
		$target.find('.form-done, .form-sending').addClass('hidden');
		getFields(target).each(setNameToId);
		restoreInitialValues(target);
		window.lastActiveField = "";
		$("[data-required] p.error.visible").removeClass("visible");
		trackInitialTags($(this), "reset");
		show($target, 'body');
	}

	function trackInitialTags(form, mode) {
		var formButtons = form.find('.btn-close[data-bs-dismiss=modal], .form-cancel, .form-submit'),
			attr = mode === "init" ? "data-analytics-init" : "data-analytics",
			val = mode === "init" ? "data-analytics" : "data-analytics-init";
		formButtons.each(function () {
			$(this).attr(attr, $(this).attr(val));
		});
	}

	function setNameToId() {
		var $el = $(this);
		var id = $el.attr('id');
		if (!id || $el.data('syncName') === false) return;
		$el.attr('name', id);
	}

	function setFocusToFirstField(target) {
		getFields(target).first().focus();
	}

	function onSubmitRequested(e) {
		var $form = $(e.currentTarget).closest(".ajax-form");
		if (submitDelay) {
			if ( !$form.attr("data-submit-allowed") || formSubmissionTimer ) {
				return false;
			}
		}
        var data = $(e.currentTarget).data("analytics");
		$form.find(".checkboxes[data-required]").each(function () {
			validRequiredCheckboxes($(this));
		});
		if (getFields($form).valid() && !$form.find(".invalid").length) {
			submitForm($form, data);
		} else {
			var firstInvalid = $form.find("[aria-invalid=true], .invalid").first(),
				screenH = window.innerHeight,
				posY = (firstInvalid.offset().top + screenH / 2) + "px";
			$form.animate({ scrollTop: posY }, 500, "swing", function () {
				firstInvalid[0].focus();
			});
		}
	}

	function submitForm($form, WTData) {
		var action = $form.attr('data-form-action'),
            array = getFields($form).serializeArray(),
            submitButton = $form.find(".form-submit")[0];
			if ($form.find('.form-sending').length) {
				$form.find('.modal-sending-backdrop').addClass('show');
				$form.find('.form-sending').removeClass('hidden');
				$form.find('.form-submit').addClass('hidden');
			}
		processFormData($form, array);
		var json = JSON.stringify(serializeObject(array));
		$.ajax({ type: 'POST', contentType: 'application/json', url: action, data: json })
            .done(function (response, status, xhr) {
            	show($form, 'success');
            	if (typeof window.sendFloodlightOnSubmit === "function") {
            		window.sendFloodlightOnSubmit(submitButton);
            	}
            	if (xhr.status === 200 && WTData) {
            		var tracking = $form.find("[data-track-analytics]"),
                        trackVal = tracking.val();
            		if (tracking.length) {
            			WTData = $.extend({}, WTData, {
            				dcsuricust: "/" + trackVal,
            				tagtitle: trackVal
            			});
            		}
            		WTData = $.extend({}, WTData, {
            			zformtypeevent: 1,
            			csg: "Successful Submit"
            		});
            	}
            })
            .fail(function () { show($form, 'failure'); })
            .always(function () {
            	if ($form.find('.form-sending').length) {
            		$form.find('.modal-sending-backdrop').removeClass('show');
            		$form.find('.form-sending').addClass('hidden');
            	}
            	$form.find('.form-submit').addClass('hidden');
            	$form.find('.form-cancel').addClass('hidden');
            	$form.find('.form-done').removeClass('hidden');
            });
	}

	function getFields(target) {
		return $(target).find('input,textarea,select');
	}

	function processFormData($form, array) {
		$.each(array, function () {
			var ajaxFormName = $form.find('[name="' + this.name + '"]').data('ajaxFormName');
			if (ajaxFormName) this.name = ajaxFormName;
			this.value = escapeInputValue( this.value );
		});
	}

	function show($container, partial) {
		var partials = ['body', 'success', 'failure'];
		for (var i = 0; i < partials.length; i++) {
			var on = (partial === partials[i]);
			$container.find('.form-' + partials[i])[on ? 'removeClass' : 'addClass']('hidden');
		}
	}

	function serializeObject(array) {
		var o = {};
		$.each(array, function () {
			if (o[this.name] !== undefined) {
				if (!o[this.name].push) {
					o[this.name] = [o[this.name]];
				}
				o[this.name].push(this.value || '');
			} else {
				o[this.name] = this.value || '';
			}
		});
		return o;
	}

	function trackAnalytics(e) {
		e.preventDefault();
		var $form = $(e.target).closest('.ajax-form');
		if ($(e.target).hasClass("form-submit")) {
			onSubmitRequested(e);
		} else {
			updateWTAnalytics($form);
		}
	}
	function updateWTAnalytics($form) {
		var trackButtons = [
            '.btn-close[data-bs-dismiss=modal]',
            '.form-cancel',
            '.form-submit'
		];
		var fields = $form.find('input:not("[type=button], [type=hidden]"), select, textarea'),
            totalFields = fields.length,
             completedFields = fields.filter(function () {
             	if ($(this).is(':radio') || $(this).is(":checkbox")) {
             		return this.checked;
             	}
             	return this.value;
             }),
            reqFields = $form.find("[required]").length,
            reqCompletedFields = completedFields.filter(function () {
            	return $(this).prop("required") || $(this).closest("[data-required]").length > 0;
            }).length,
            WTData = {};
		$form.find("[data-required]").each(function () {
			var reqNum = parseInt($(this).data("required"), 10);
			reqFields += isNaN(reqNum) ? 1 : reqNum;
		});
		$($form.find(trackButtons.join(","))).each(function () {
			WTData = $.extend($(this).data("analytics"), {
				compn: window.lastActiveField,
				filltxt: completedFields.length,
				numfields: totalFields
			});
			if ($(this).hasClass("form-submit")) {
				WTData.manual = reqCompletedFields === reqFields;
				delete WTData.sc_goals;
			}
			$(this).attr("data-analytics", JSON.stringify(WTData));
		});
	}

	function initRequiredCheckboxes() {
		var numRequired,
			spanText = " option";
		boxGroups = $(".ajax-form .checkboxes[data-required]").each(function (i, v) {
			numRequired = $(v).data("required");
			spanText += numRequired > 1 ? "s" : "";
			$(v).find(".error span").text(numRequired + spanText);
		});
	}

	function validRequiredCheckboxes(fgroup) {
		var numRequired = fgroup.data("required"),
			inputs = fgroup.find("input"),
			labels = fgroup.find("input + label"),
			checkedInputs = fgroup.find("input").filter(function () {
				return $(this).is(":checked");
			}),
			numChecked = checkedInputs.length,
			validRule = numChecked >= numRequired;
		inputs[validRule ? 'removeClass' : 'addClass']('invalid').attr("aria-invalid", !validRule);
		fgroup.find("p.error")[validRule ? 'removeClass' : 'addClass']('visible');
	}

	function escapeInputValue(val) {
		return $.fn.xss.sanitize(val);
	}

	function initSubmissionDelay() {
		if (submitDelay === undefined) return false;
		toggleFormSubmission(false);
		clearTimeout(formSubmissionTimer);
		formSubmissionTimer = null;
		formSubmissionTimer = setTimeout(function (){
			formSubmissionTimer = null;
			toggleFormSubmission(true);
		}, submitDelay.get);
	}

	function toggleFormSubmission(state) {
		$forms = $(".ajax-form");
		var submitAllowed = $forms.attr("data-submit-allowed");
		$forms.attr("data-submit-allowed", state ? "true" : "");
		$forms.find(".form-submit")[state ? "removeAttr" : "attr"]("disabled", "");
	}

	function initFormRadios(target) {
		var $form = $(target),
			radioComps = $form.find(".component[data-required]");
		radioComps.each(function(i, comp) {
			$(comp).find("label.error").attr("for", $(comp).find("input:first").attr("name") );
		});
	}

}(window.jQuery));
